module.exports = __webpack_public_path__ + "media/application/images/svgs/package-1e1d59c9afe7902b4cb2c2dea2b86dcd.svg";